import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import initialState from './store/initialState';
import configureStore from './store/configureStore';
import {saveConfig} from "./actions/configActions";

const rootEl = document.getElementById('root');
const store = configureStore(initialState);
const postUrl = rootEl.getAttribute('data-posturl');

store.dispatch(saveConfig({
    postUrl: postUrl,
}))

ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider muiTheme={getMuiTheme()}>
            <App/>
        </MuiThemeProvider>
    </Provider>
    ,
    rootEl
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js